import { VIDEO_SOURCES, EXTERNAL_VIDEO_SOURCES } from '@wix/wix-vod-constants/common';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import { includes } from 'lodash';
export const isDownloadAllowed = video => video.allowDownload;
export const isExternalVideo = video => Boolean(video.mediaExternUrl);
export const isExternalVideoSource = videoSource => EXTERNAL_VIDEO_SOURCES.includes(videoSource);
export const isVideoFromComputer = _ref => {
  let {
    videoSource
  } = _ref;
  return videoSource === VIDEO_SOURCES.COMPUTER;
};
export const isVideoOriginallyLive = _ref2 => {
  let {
    videoSource
  } = _ref2;
  return videoSource === VIDEO_SOURCES.LIVE;
};
export const isFacebookVideo = _ref3 => {
  let {
    videoSource
  } = _ref3;
  return videoSource === VIDEO_SOURCES.FACEBOOK;
};
export const isYoutubeVideo = _ref4 => {
  let {
    videoSource
  } = _ref4;
  return videoSource === VIDEO_SOURCES.YOUTUBE;
};
export const isLiveVideo = function (_temp) {
  let {
    itemType
  } = _temp === void 0 ? {} : _temp;
  return includes([ItemType.ItemLive, ItemType.ItemScheduled, ItemType.ItemLiveFinalize], itemType);
}; // TODO check if works
//# sourceMappingURL=video-origin.js.map